/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { HighchartReactWrapper } from '@bingads-webui-react/highchart-react-wrapper';
import { keyCode } from '@bingads-webui/keycode';

import {
  CHART_TYPES,
} from './consts';
import { getChartOptions } from './chart-configuration';
import { WithSeriesData } from './with-series-data';
import { WithCategories } from './with-categories';

const CHART_TYPE = {
  COLUMN: 'column',
  LINE: 'line',
};

class AdvisorChartView extends React.Component {
  static defaultProps = {
    type: null,
    primarySegmentType: null,
    secondarySegment: null,
    title: null,
    subType: null,
    categories: [],
    localizeCategory: _.noop,
    enableLegend: true,
    onChartRenderedCallback: _.noop,
  };

  static propTypes = {
    selectedMetric: PropTypes.string.isRequired,
    primarySegmentType: PropTypes.string,
    secondarySegment: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.oneOf(_.values(CHART_TYPES)),
    subType: PropTypes.string,
    i18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    localizeCategory: PropTypes.func,
    categories: PropTypes.arrayOf(PropTypes.string),
    series: PropTypes.arrayOf(PropTypes.object).isRequired,
    enableLegend: PropTypes.bool,
    onChartRenderedCallback: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      labelsVisibilityUpdated: false,
    };
  }

  onLabelClick = (index) => {
    // flip visible property
    // only when it was false, it becomes true, all others (true/null/undefined) now becomes false
    this.props.series[index].visible = (this.props.series[index].visible === false);

    // manually trigger a re-render
    this.setState({
      labelsVisibilityUpdated: !this.state.labelsVisibilityUpdated,
    });
  };

  onLabelKeyDown = (event, index) => {
    if (event.keyCode === keyCode.Enter || event.keyCode === keyCode.Space) {
      this.onLabelClick(index);
    }
  };

  buildVNextLegendLabels(chartOptions) {
    const labels = [];

    _.each(chartOptions.series, (sery, index) => {
      const label = (
        <li key={labels.length} >
          <div
            className={`${'legend-label'} ${chartOptions.chart.type} ${sery.visible === false ? 'disabled' : ''}`}
            title={`${sery.name}`}
            onClick={() => this.onLabelClick(index)}
            onKeyDown={event => this.onLabelKeyDown(event, index)}
            tabIndex={0}
            role="button"
          >
            {sery.name}
          </div>
        </li>
      );
      labels.push(label);
    });

    return (
      <div className={`${'vnext-legend-labels-container'} ${chartOptions.chart.type}`}>
        <ul>
          {labels}
        </ul>
      </div>
    );
  }

  renderRow(chartOptions, element) {
    return (
      <div
        className="charts-label"
        style={{
          fontFamily: 'Arial',
          fontSize: '12px',
          fontWeight: 'normal',
          paddingLeft:
            chartOptions.chart.spacingLeft +
            chartOptions.chart.marginLeft +
            10,
          paddingRight:
            chartOptions.chart.spacingRight +
            chartOptions.chart.marginRight +
            10,
          textAlign: 'center',
        }}
      >
        {element}
      </div>
    );
  }

  render() {
    const chartOptions = getChartOptions({
      i18n: this.props.i18n,
      type: this.props.type,
      subType: this.props.subType,
      metric: this.props.selectedMetric,
      primarySegmentType: this.props.primarySegmentType,
      secondarySegment: this.props.secondarySegment,
      series: this.props.series,
      localizeCategory: this.props.localizeCategory,
      enableLegend: this.props.enableLegend,
    });

    return (
      <div className="advisor-chart">
        <div className="row">
          <div className="col-sm-12">
            <HighchartReactWrapper
              options={chartOptions}
              onChartRenderedCallback={this.props.onChartRenderedCallback}
            />
          </div>
        </div>
        {chartOptions.chart.type === CHART_TYPE.COLUMN &&
          this.props.title &&
          this.renderRow(
            chartOptions, (
              <span>
                {this.props.title}
              </span>
            )
          )
        }
        {chartOptions.chart.type !== CHART_TYPE.COLUMN &&
          this.props.subType !== 'Line_Weekly_Chart' &&
          this.renderRow(
            chartOptions, (
              <div className="row">
                <div className="col-sm-6">
                  <span
                    className="xAxis-label-left"
                    style={{
                      float: 'left',
                    }}
                  >
                    {this.props.localizeCategory(_.first(this.props.categories))}
                  </span>
                </div>
                <div className="col-sm-6">
                  <span
                    className="xAxis-label-right"
                    style={{
                      float: 'right',
                    }}
                  >
                    {this.props.localizeCategory(_.last(this.props.categories))}
                  </span>
                </div>
              </div>
            )
          )
        }
        {
          this.props.enableLegend && this.buildVNextLegendLabels(chartOptions)
        }
      </div >
    );
  }
}

export const AdvisorChart =
  WithCategories(WithSeriesData(AdvisorChartView));
